export default __webpack_public_path__ + "static/media/rtr-160.6904444b.svg";